import { Pipe, PipeTransform } from '@angular/core';
import { resolveClothingItemNameKey } from './clothing-item-name-key.helper';

@Pipe({
  name: 'clothingItemNameKey'
})
export class ClothingItemNameKeyPipe implements PipeTransform {
  transform(value: string): string {
    return resolveClothingItemNameKey(value);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/clothing-item-name-key.pipe.ts